import { API_BASE } from './api';

/**
 * Fetch an order's invoice HTML with the current auth token and open it in a
 * new tab using a Blob URL (safer than document.write — avoids XSS injection
 * into the parent origin's document and does not require raw string writes).
 *
 * We open the tab by programmatically clicking an anchor with
 * `target="_blank" rel="noopener noreferrer"` rather than
 * `window.open(url, '_blank', 'noopener,noreferrer')` because the latter
 * always returns `null` per HTML spec whenever `noopener` is set — that would
 * make it impossible to distinguish success from popup-blocker failure.
 *
 * Returns true if the invoice request succeeded and the tab was launched;
 * false only if the network/HTTP request failed. Popup-blocker cases still
 * return true (the click was dispatched); the browser tab UI will surface any
 * blocked-popup indicator to the user.
 */
export async function openInvoice(orderId) {
  return _openOrderPdf(orderId, 'invoice');
}

export async function openConfirmation(orderId) {
  return _openOrderPdf(orderId, 'confirmation');
}

async function _openOrderPdf(orderId, kind /* 'invoice' | 'confirmation' */) {
  try {
    const token = localStorage.getItem('jw_token');
    const res = await fetch(`${API_BASE}/orders/${orderId}/${kind}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) {
      console.error(`open ${kind}: request failed`, res.status);
      return false;
    }
    const html = await res.text();
    const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
    return true;
  } catch (err) {
    console.error(`open ${kind} failed:`, err);
    return false;
  }
}
